import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const selectors = {
    el: '.js-page-anchors:not(.is-ready)',
    anchor: '.js-page-anchors__anchor',
    link: '.js-page-anchors__link',
    main: '.js-main'
};

const dom = {};

const build = el => {
    el.classList.add('is-ready');
    el.anchors = [...document.querySelectorAll(selectors.anchor)];
    el.anchors.forEach(anchor => {
        const link = anchor.querySelector(selectors.link);
        if (link.href === window.location.href.split(/[?#]/)[0]) {
            el.scrollTo(anchor.offsetLeft, 0);

            const idx = el.anchors.indexOf(anchor);
            for (let i = 0; i < idx; i++) {
                el.anchors[i].style.backgroundSize = '100% 3px';
            }

            anchor.animation = gsap.from(anchor, {
                scrollTrigger: {
                    trigger: dom.main,
                    start: 'top top',
                    end: `bottom bottom`,
                    onUpdate: self => {
                        anchor.style.backgroundSize = `${self.progress*100}% 3px`;
                    }
                }
            });
        }
    });
}

const reset = el => {
    if (!el.anchors) return;
    el.classList.remove('is-ready');
    el.anchors.forEach(anchor => {
        if (!anchor.animation) return;
        anchor.animation.scrollTrigger.kill();
    });
}

const init = () => {
    dom.els = document.querySelectorAll(selectors.el);
    dom.main = document.querySelector(selectors.main);
    dom.els.forEach(reset);
    dom.els.forEach(build);
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;